/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import uuid from 'uuid';
import IconMapping from '../../../../utils/iconMapping';
import { PDPAnalytics } from '../../../../analytics';
import { PDP_SECTION, HELP_SUPPORT_LINK } from '../../../../utils/pdpUtils/pdpEnums';
import TranslationUtil from '../../../../utils/translation';


class HelpAndSupport extends Component {
    onHelpLinkCLick(e, helpLink) {
        const { PDPDataObject: { actionHandlerCallback } } = this.props;
        const { sectionId } = this.sectionData;
        const guid = uuid.v4();

        PDPAnalytics.helpLinkClick(helpLink, guid, sectionId);
        const actionParam = {
            actionObject: helpLink,
            guid,
        };
        actionHandlerCallback(e, sectionId, helpLink.actionId, actionParam);
    }

    get sectionData() {
        const { PDPDataObject } = this.props;
        return this.validateAndProcessData(PDPDataObject);
    }

    validateAndProcessData({ contentfulData }) {
	    const helpAndSupportModel = {
	        sectionId: PDP_SECTION.HELP_AND_SUPPORT,
            helpLinkList: [],
	    };
	    if (contentfulData.troubleshootLink && contentfulData.troubleshootLink.url) {
	        helpAndSupportModel.helpLinkList.push({
	            actionId: HELP_SUPPORT_LINK.TROUBLESHOOTING_AND_HELP,
	            url: contentfulData.troubleshootLink.url,
	            urlData: contentfulData.troubleshootLink,
	        });
	    }
	    if (contentfulData.contactUsLink && contentfulData.contactUsLink.url) {
	        helpAndSupportModel.helpLinkList.push({
	            actionId: HELP_SUPPORT_LINK.CONTACT_US,
	            url: contentfulData.contactUsLink.url,
	            urlData: contentfulData.contactUsLink,
	        });
	    }
	    if (contentfulData.moreTutorialsLink && contentfulData.moreTutorialsLink.url) {
	        helpAndSupportModel.helpLinkList.push({
	            actionId: HELP_SUPPORT_LINK.TUTORIALS,
	            url: contentfulData.moreTutorialsLink.url,
	            urlData: contentfulData.moreTutorialsLink,
	        });
	    }
	    if (contentfulData.communityLink && contentfulData.communityLink.url) {
	        helpAndSupportModel.helpLinkList.push({
	            actionId: HELP_SUPPORT_LINK.COMMUNITY_AND_FORUM,
	            url: contentfulData.communityLink.url,
	            urlData: contentfulData.communityLink,
	        });
	    }
	    return helpAndSupportModel;
    }

    renderHelpLinks() {
        const { helpLinkList } = this.sectionData;
        const { LinkOut } = IconMapping;
        return helpLinkList.map(helpLink => (
            <a
                className="help-link"
                tabIndex={0}
                role="link"
                aria-label={TranslationUtil.getMessage(`ccx.pdp.help-and-support.${helpLink.actionId}`)}
                key={helpLink.actionId}
                onClick={(e) => { this.onHelpLinkCLick(e, helpLink); }}
                onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                        this.onHelpLinkCLick(e, helpLink);
                    }
                }}>
                {TranslationUtil.getMessage(`ccx.pdp.help-and-support.${helpLink.actionId}`)}
                <LinkOut size="XS" className="help-link-linkout" />
            </a>
        ));
    }

    render() {
        return this.sectionData && (
            <div className="help-and-support right-panel-compt">
                <div className="help-support-header">
                    {TranslationUtil.getMessage('ccx.pdp.help-and-support.section-name')}
                </div>
                <div className="help-links">
                    {this.renderHelpLinks()}
                </div>
            </div>
        );
    }
}

export default observer(HelpAndSupport);
